export class RefreshAttemptBudget {
  private attemptCount = 0
  private lastAttemptAt = 0

  constructor(
    private readonly maxAttempts: number,
    private readonly windowMs: number,
  ) {}

  get count(): number {
    return this.attemptCount
  }

  canAttempt(now = Date.now()): boolean {
    this.resetIfWindowElapsed(now)
    return this.attemptCount < this.maxAttempts
  }

  recordAttempt(now = Date.now()): void {
    this.resetIfWindowElapsed(now)
    this.attemptCount += 1
    this.lastAttemptAt = now
  }

  reset(): void {
    this.attemptCount = 0
    this.lastAttemptAt = 0
  }

  private resetIfWindowElapsed(now: number): void {
    if (this.lastAttemptAt && now - this.lastAttemptAt > this.windowMs) {
      this.reset()
    }
  }
}
